import React from 'react'
import { createStyles, withStyles } from '@material-ui/core'

const styles = () => {
  return createStyles({
    item: {
      listStyle: 'none',
      '& + &': {
        marginTop: '1rem',
      },
    },
  })
}

const Item = ({ classes, children }) => {
  return <li className={classes.item}>{children}</li>
}

export default withStyles(styles)(Item)
